import { SelectedUserStatusesEnum } from '../constants';

export const getStatusColor = (status: SelectedUserStatusesEnum) => {
  switch (status) {
    case SelectedUserStatusesEnum.SUCCESS:
      return 'success';
    case SelectedUserStatusesEnum.ERROR:
      return 'error';
    case SelectedUserStatusesEnum.NOT_FOUND:
      return 'warning';
    case SelectedUserStatusesEnum.PENDING:
    default:
      return 'default';
  }
};

export const getStatusLabel = (status: SelectedUserStatusesEnum) => {
  switch (status) {
    case SelectedUserStatusesEnum.SUCCESS:
      return 'Success';
    case SelectedUserStatusesEnum.ERROR:
      return 'Error';
    case SelectedUserStatusesEnum.NOT_FOUND:
      return 'Not Found';
    case SelectedUserStatusesEnum.PENDING:
    default:
      return 'Pending';
  }
};
